import { StorageAPI } from '@makyoapp/makyo-sdk'
import { IUploadResult } from '@makyoapp/makyo-sdk/models/Files'

import { dbWorkerRequest } from '@/workers/worker-request'

import { sanitizeFileName } from './utils'

/**
 * utility function to upload a file to the current org from the actions
 *
 */
export async function actionUpload(file: File, currentOrgId: string, folderPath = ''): Promise<IUploadResult> {
  const name = sanitizeFileName(file.name)

  if (window.appMode === 'public' && window.dbWorker) {
    // create uint8 array from file
    const data = new Uint8Array(await file.arrayBuffer())
    return dbWorkerRequest({
      type: 'pub_req_fiu',
      payload: { name, folder: folderPath, mode: '', data },
    })
  }

  return StorageAPI.ReqUploadForOrg(name, currentOrgId, file, 0 as unknown as AbortSignal, folderPath)
}
